(function () {
    'use strict';
    /*
     * Copyright (c) 2019 In Hand Health.
     * All rights reserved.
     */

    /**
     * A service for providing internationalizable strings common to ops and console.
     *
     * Ideally, no internationalizable string would appear anywhere in the application other than this file.
     * That is unfortunately not the case as of the time of this writing.
     */
    angular
        .module('ihh-common-web')
        .service('CommonI18nService', CommonI18nService);

    CommonI18nService.$inject = ['_'];
    function CommonI18nService(_) {
        var self = this;

        // Lots of common string
        self.continuingCare = 'Concierge Care';
        self.continuingCareProduct = 'Concierge Care Product';
        self.continuingCareSettings = 'Concierge Care Settings';
        self.template = 'template';
        self.templates = 'templates';
        self.therapist = 'therapist';
        self.patient = 'patient';

        self.clearButtonLabel = "Clear";

        self.pages = {
            scripForm: {
                allowLogging: 'Allow logging activities without viewing',
                allowLastSurveyValues: 'Allow using last values from survey',
                workoutOnlyWhenDue: 'Only allow logging activities when due',
                doNotSurvey: 'Do not survey patient when completed',
                noCompliance: 'Do not consider when calculating compliance',
                performOnce: 'Expire after patient performs once',
                advanceWorkflow: 'Advance workflow when completed',
                notifyOnPerform: 'Notify when activity performed',
                autoExpireMessage: 'Auto-expire Message',
                autoExpireUrl: "Auto-expire URL",
                overdueDays: 'Delay overdue notification days',
                gamifySequence: 'Perform in gamified sequence'
            }
        };

        /**
         * Converts the passed string to start case.
         */
        self.startCase = function (string) {
            return _.startCase(string);
        };
    }
})();
